// Sliders are built by assets/scripts_swiper.js via [data-swiper-instance].

const deleteRepeatedCarousels = function(){
  const items = document.querySelectorAll('.section-collection-carousel .collection-item.collection-wrapper');
  const seenHandles = new Set();
  items.forEach(item => {
    const handle = item.getAttribute('data-collection-handle');
    if (seenHandles.has(handle)) {
      item.remove();
    } else {
      seenHandles.add(handle);
    }
  });
}

const closeShowMoreOnSlideChange = function(swiper){
  swiper.on('slideChange', function () {
    this.slides.forEach((slide) => {
      let showMore = slide.querySelector('.show-more');
      if(showMore && showMore.textContent == 'Close'){
        showMore.click();
      }
    })
  });
}

document.addEventListener('swiper:init', function(event){
  if (!event.target.closest('.collection-carousel')) return;
  closeShowMoreOnSlideChange(event.detail.swiper);
});

// Sliders built before this listener was registered
document.querySelectorAll('.collection-carousel .carousel-wrapper.swiper-initialized').forEach((carouselSlider) => {
  closeShowMoreOnSlideChange(carouselSlider.swiper);
});

window.addEventListener('load', deleteRepeatedCarousels);